import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kdz9ca4wq: FaireProductEntity = {
  token: "p_4kdz9ca4wq",
  type: "product",
  name: "White Christmas Tree Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/0e595170d3e5960163b9c7b1de8da045aa58d1bc33327473d4e5ed5a8eb78bb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/677422f840021bd1e84e0d12f68560ca7c21954f89cd2b3e14b3980cd58ffe23.jpeg",
    "https://cdn.faire.com/fastly/f276d6e229463f15ac3f5f2287599857acd2904e3621d99efebed61a9d45891f.jpeg"
  ],
  priceDollars: 14,
  description: "White Christmas Tree Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings\n\nWhite Christmas Tree Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings - Fashion Earrings for Her\n\nThese lightweight earrings that you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:07.878Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
